import React from "react";
import PricingSectionPending from "./pricing/PricingSectionPending";
import PricingSectionRejected from "./pricing/PricingSectionRejected";
import PricingSectionAwaitingApproval from "./pricing/PricingSectionAwaitingApproval";
import PricingSectionToBeReimbursed from "./pricing/PricingSectionToBeReimbursed";
import PricingSectionReimbursed from "./pricing/PricingSectionReimbursed";
import { getVoidAdminStage } from "../../../../data/flight/order/getVoidAdminGuidance";

function VoidConfimationPricingSection({ data }) {
  const stage = getVoidAdminStage(data);

  switch (stage) {
    case "declined":
    case "validation_failed":
    case "supplier_failed":
    case "failure_settled":
      return <PricingSectionRejected data={data} />;
    case "needs_manual_void":
    case "auto_processing":
    case "awaiting_supplier":
      return <PricingSectionAwaitingApproval data={data} />;
    case "settlement_pending":
    case "settlement_failed":
      return <PricingSectionToBeReimbursed data={data} />;
    case "completed":
      return <PricingSectionReimbursed data={data} />;
    case "needs_manual_review":
    case "send_failed":
    default:
      return <PricingSectionPending data={data} />;
  }
}

export default VoidConfimationPricingSection;
